// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thm-container {
  width: 100%;
  max-width: 1200px;
  padding-left: 15px;
  padding-right: 15px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.comparePolicyScreenTopHeading {
  background-color: #424e71;
  color: #fff;
  padding: 10px 0px;
  text-align: left;
  border: 1px solid #323c5a;
}
.custom-select {
  height: 35px;
  border-radius: inherit;
}
.compareDetailssection {
  background-color: #fff;
}

.compareDetailssectionleft,
.compareDetailssectionright {
  border: 1px solid #dfdfdf;
  padding-top: 0px;
  padding-bottom: 10px;
}

.compareDetailssection div#myTabContent {
  padding: 10px;
}

.tab-content > .active {
  display: block;
}
.react-form-wizard .wizard-tab-content {
  min-height: 100px;
  padding: 30px 20px 10px;
  text-align: start !important;
}

.logoskybluecolor {
  color: #3ca8e8;
  margin-bottom: 20px;
  position: relative;
}

.mainPolicyHeading {
  position: relative;
  padding: 20px 0px;
}

h3.logoskybluecolor:before {
  content: "";
  position: absolute;
  top: 35px;
  height: 5px;
  width: 55px;
  background-color: #25335b;
}

h3.logoskybluecolor:after {
  content: "";
  position: absolute;
  left: 15px;
  top: 37px;
  height: 1px;
  width: 95%;
  max-width: 255px;
  background-color: #25335b;
}

.mainPolicyHeading h4:before {
  content: "";
  position: absolute;
  top: 48px;
  height: 5px;
  width: 55px;
  background-color: #25335b;
}

.mainPolicyHeading h4:after {
  content: "";
  position: absolute;
  left: 15px;
  top: 50px;
  height: 1px;
  width: 95%;
  max-width: 255px;
  background-color: #25335b;
}

.react-datepicker__navigation--years-upcoming {
  top: 0px;
}
.react-datepicker__navigation--years-previous {
  top: 1px;
}
/* Customize the color and icon of the month dropdown arrow */
.react-datepicker__month-dropdown-arrow {
  border-top-color: red; /* Change the color as per your preference */
}
.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #677caa;
  color: white;
}
/* Customize the color and icon of the year dropdown arrow */
.react-datepicker__year-dropdown-arrow {
  border-top-color: green; /* Change the color as per your preference */
}
.react-datepicker__navigation-icon::before {
  border-color: #fff;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: block;
  height: 9px;
  position: absolute;
  top: 6px;
  width: 9px;
}
/* .react-datepicker__navigation {
  background-color: #b9c7e1;
} */
.react-datepicker__navigation-icon--next::before {
  transform: rotate(45deg);
  left: -7px;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow,
.react-datepicker__navigation-icon::before {
  border-color: #677caa;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: block;
  height: 9px;
  position: absolute;
  top: 6px;
  width: 9px;
}
.rgikycdob {
  width: 300px;
}

`, "",{"version":3,"sources":["webpack://./src/SidebarComponent/ICICI/ICICIPoliciesKYCPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA,6DAA6D;AAC7D;EACE,qBAAqB,EAAE,4CAA4C;AACrE;AACA;;;EAGE,yBAAyB;EACzB,YAAY;AACd;AACA,4DAA4D;AAC5D;EACE,uBAAuB,EAAE,4CAA4C;AACvE;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;;GAEG;AACH;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;;;;EAIE,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,YAAY;AACd","sourcesContent":[".thm-container {\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  display: block;\r\n}\r\n\r\n.comparePolicyScreenTopHeading {\r\n  background-color: #424e71;\r\n  color: #fff;\r\n  padding: 10px 0px;\r\n  text-align: left;\r\n  border: 1px solid #323c5a;\r\n}\r\n.custom-select {\r\n  height: 35px;\r\n  border-radius: inherit;\r\n}\r\n.compareDetailssection {\r\n  background-color: #fff;\r\n}\r\n\r\n.compareDetailssectionleft,\r\n.compareDetailssectionright {\r\n  border: 1px solid #dfdfdf;\r\n  padding-top: 0px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.compareDetailssection div#myTabContent {\r\n  padding: 10px;\r\n}\r\n\r\n.tab-content > .active {\r\n  display: block;\r\n}\r\n.react-form-wizard .wizard-tab-content {\r\n  min-height: 100px;\r\n  padding: 30px 20px 10px;\r\n  text-align: start !important;\r\n}\r\n\r\n.logoskybluecolor {\r\n  color: #3ca8e8;\r\n  margin-bottom: 20px;\r\n  position: relative;\r\n}\r\n\r\n.mainPolicyHeading {\r\n  position: relative;\r\n  padding: 20px 0px;\r\n}\r\n\r\nh3.logoskybluecolor:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 35px;\r\n  height: 5px;\r\n  width: 55px;\r\n  background-color: #25335b;\r\n}\r\n\r\nh3.logoskybluecolor:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 15px;\r\n  top: 37px;\r\n  height: 1px;\r\n  width: 95%;\r\n  max-width: 255px;\r\n  background-color: #25335b;\r\n}\r\n\r\n.mainPolicyHeading h4:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 48px;\r\n  height: 5px;\r\n  width: 55px;\r\n  background-color: #25335b;\r\n}\r\n\r\n.mainPolicyHeading h4:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 15px;\r\n  top: 50px;\r\n  height: 1px;\r\n  width: 95%;\r\n  max-width: 255px;\r\n  background-color: #25335b;\r\n}\r\n\r\n.react-datepicker__navigation--years-upcoming {\r\n  top: 0px;\r\n}\r\n.react-datepicker__navigation--years-previous {\r\n  top: 1px;\r\n}\r\n/* Customize the color and icon of the month dropdown arrow */\r\n.react-datepicker__month-dropdown-arrow {\r\n  border-top-color: red; /* Change the color as per your preference */\r\n}\r\n.react-datepicker__year-option:hover,\r\n.react-datepicker__month-option:hover,\r\n.react-datepicker__month-year-option:hover {\r\n  background-color: #677caa;\r\n  color: white;\r\n}\r\n/* Customize the color and icon of the year dropdown arrow */\r\n.react-datepicker__year-dropdown-arrow {\r\n  border-top-color: green; /* Change the color as per your preference */\r\n}\r\n.react-datepicker__navigation-icon::before {\r\n  border-color: #fff;\r\n  border-style: solid;\r\n  border-width: 3px 3px 0 0;\r\n  content: \"\";\r\n  display: block;\r\n  height: 9px;\r\n  position: absolute;\r\n  top: 6px;\r\n  width: 9px;\r\n}\r\n/* .react-datepicker__navigation {\r\n  background-color: #b9c7e1;\r\n} */\r\n.react-datepicker__navigation-icon--next::before {\r\n  transform: rotate(45deg);\r\n  left: -7px;\r\n}\r\n.react-datepicker__year-read-view--down-arrow,\r\n.react-datepicker__month-read-view--down-arrow,\r\n.react-datepicker__month-year-read-view--down-arrow,\r\n.react-datepicker__navigation-icon::before {\r\n  border-color: #677caa;\r\n  border-style: solid;\r\n  border-width: 3px 3px 0 0;\r\n  content: \"\";\r\n  display: block;\r\n  height: 9px;\r\n  position: absolute;\r\n  top: 6px;\r\n  width: 9px;\r\n}\r\n.rgikycdob {\r\n  width: 300px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
